// view/index.ts
export * from "prosemirror-view";